import { hasModule } from '../ModuleUtil';
import { MODULE_TYPES } from '../../../../constants';
/**
 * These functions act as intermediate solutions for handling view configurations demanded by Sage until we can find a
 * good approach to unifying the view restrictions originating from Sage with the view restrictions originating from CompanySetup.
 */
function sageRestrictedFinancialModules() {
    const isPSAFullFinancials = hasModule(MODULE_TYPES.SAGE_PSA_FULL_FINANCIALS);
    const isPSARevenueOnly = hasModule(MODULE_TYPES.SAGE_PSA_REVENUE_ONLY);
    return { isPSAFullFinancials, isPSARevenueOnly };
}
export function sageFinancialsRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageCostRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageProfitRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageMarginRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageRevenueRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageProjectBudgetMoneyRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageProjectRevenueRecognitionRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageProjectTaskBreakdownRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageCreateExpenseRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageCreateInvoiceRestricted() {
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED) && !isPSARevenueOnly && !isPSAFullFinancials;
}
export function sageReportingRestricted() {
    const sagePSARestricted = hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED);
    const sagePSAReportsMenuAccess = hasModule(MODULE_TYPES.SAGE_PSA_REPORTS_MENU_ACCESS);
    return sagePSARestricted && !sagePSAReportsMenuAccess;
}
export function sageAdminFinanceExpenseCategoriesRestricted() {
    const sagePSARestricted = hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED);
    const { isPSAFullFinancials } = sageRestrictedFinancialModules();
    return sagePSARestricted && !isPSAFullFinancials;
}
export function sageAdminFinanceRateCardRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageAdminFinanceCurrenciesRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && !isPSARevenueOnly;
}
export function sageAdminFinanceBudgetToleranceRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageAdminFinanceInvoicingRestricted() {
    if (!hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) {
        return false;
    }
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return !isPSAFullFinancials && isPSARevenueOnly;
}
export function sageFinanceMenuRestricted() {
    return (hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED) &&
        (sageFinancialsRestricted() || !hasModule(MODULE_TYPES.SAGE_PSA_FINANCE_MENU_ACCESS)));
}
export function isSagePSAWithFinancialsAccess() {
    const { isPSAFullFinancials, isPSARevenueOnly } = sageRestrictedFinancialModules();
    return hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED) && (isPSARevenueOnly || isPSAFullFinancials);
}
